import { InjectionToken } from "@angular/core";
import { TokenFactory } from "src/app/tokens/token-factory";

export const TEMPLATE_APPOINTMENT_REMINDER_TOKEN = new InjectionToken<
  TokenFactory<string>
>("template_appointment_reminder_token");
